export default __webpack_public_path__ + "static/media/edot.42e7a00f.PNG";